import * as React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { Grid } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { Rightarrow } from '@/icons/Rightarrow';
import { BreadcrumbData } from '@/utils/breadcrumb';
import { getCookie } from '@/utils';

interface BreadcrumbProps {
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  separableicon?: React.ReactNode;
  maxItems?: number;
  separator?: any;
  sx?: any;
  fontSize?: number;
  fontWeight?: number;
  breaddata?: any;
  md?: any;
}

const Breadcrumb = ({
  startIcon,
  fontSize = 14,
  fontWeight = 0,
  separator = '>',
  sx,
  endIcon,
  separableicon,
  md,
  ...other
}: BreadcrumbProps) => {
  const domainName = getCookie('xsm_user_domain');
  const navigate = useNavigate();
  const location = useLocation();

  const data: any = [];
  const list = location.pathname.split('/');
  list.shift();
  BreadcrumbData.map((item: any) => {
    list.map((childItem: any) => {
      if (childItem === item.url.split('/')[1]) {
        if (item.url == '/adv-domain-setup' && domainName !== 'master') {
          data.push({ key: `Domain Setup - ${domainName}`, url: item.url });
        } else {
          data.push({ key: item.label, url: item.url });
        }
      }
    });
  });

  const handleClick = (path: string) => navigate(path);

  return (
    <div role="presentation">
      <Breadcrumbs
        role="presentation"
        separator={separableicon ? <Rightarrow /> : separator}
        aria-label="breadcrumb"
        sx={{
          svg: {
            marginLeft: '32px',
            marginRight: '32px',
          },
        }}
        {...other}
      >
        {data?.map((item: any, index: any) => {
          return (
            <Grid
              key={index}
              sx={{
                display: 'flex',
                alignItems: 'center',
                cursor: data.length !== index + 1 ? 'pointer' : '',
                pointerEvents: data.length !== index + 1 ? 'all' : 'none',
                padding: '8px 16px',
                borderRadius: '8px',
                '&:hover': {
                  boxShadow:
                    data.length !== index + 1
                      ? '0px 4px 8px 0px rgba(0, 0, 0, 0.10), 0px -4px 8px 0px rgba(0, 0, 0, 0.05)'
                      : '',
                },
                ...sx,
              }}
              color={data.length === index + 1 ? '#242424' : '#737373'}
              onClick={() => handleClick(item.url)}
              fontWeight={700}
              fontSize={'20px'}
              fontFamily={'Poppins'}
              className={data.length === index + 1 ? 'last-crumb' : '#737373'}
            >
              {startIcon && item.startIcon}
              {item?.key && item?.key}
              {endIcon && item.startIcon}
            </Grid>
          );
        })}
      </Breadcrumbs>
    </div>
  );
}

export default Breadcrumb;